module.exports = __webpack_public_path__ + "img/8.d077b702.jpg";